<div *ngIf="userSearchInfo">
<h6>
<mat-radio-group>
  <mat-radio-button class="half-width" value="file" [checked]="true" >File Search</mat-radio-button>
  <mat-radio-button class="half-width" value="sample" [routerLink]="['sample-search']">Sample Search</mat-radio-button>
</mat-radio-group>
</h6>
<form id="searchForm" class="search-form" (ngSubmit)="onSubmit()" #myForm="ngForm" [ngFormOptions]="{updateOn: 'submit'}">
<!-- ID SEARCH   -->

  <mat-form-field class="full-width">
      <input matInput [(ngModel)]="searchCriteria.submissionIdentifier" name="submissionIdentifier" placeholder="Submission Identifier" autocomplete="off" >
  </mat-form-field>

<!-- ID TYPE RADIOS -->

  <mat-radio-group class="full-width" [(ngModel)]="searchCriteria.submissionIdentifierType" name="submissionIdentifierType">
    <mat-radio-button class="third-width" value="fileId">File ID</mat-radio-button>
    <mat-radio-button class="third-width" value="filename">File Name</mat-radio-button>
    <mat-radio-button class="third-width" value="uuid">UUID</mat-radio-button>
  </mat-radio-group>

<!-- STATUS DROPDOWN   -->

<ng-select [items]="userSearchInfo.status"
            bindLabel="name"
            bindValue="name"
            addTagText="fsjkldfnasjlkdnf"
            dropdownPosition="bottom"
           [multiple]="true"
           [closeOnSelect]="false"
            placeholder="Status"
           [(ngModel)]="searchCriteria.status"
            name="status">
</ng-select>


<!-- START DATE PICKER -->

<mat-form-field id="startDateFormField" class="half-width date-picker">
    <input (input)="onStartDateChange($event.target.value)" (onchange)="onStartDateChange($event.target.value)" id="startDate" matInput [min]="minDate" [max]="maxDate" [matDatepicker]="startDatePicker" [(ngModel)]="searchCriteria.startDate" name="startDate" placeholder="Start Date">
    <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #startDatePicker (selectedChanged)="onStartDateSelected($event)"></mat-datepicker>
    <mat-hint>mm/dd/yyyy</mat-hint>
  </mat-form-field>

  <mat-form-field id="startTimeFormField" class="third-width time-picker">
    <input matInput id="startTime" type="time" placeholder="Start time">
  </mat-form-field>

  <br>
<!-- END DATE PICKER -->

<mat-form-field id="endDateFormField" class="half-width date-picker">
  <input (input)="onEndDateChange($event.target.value)" (onchange)="onEndDateChange($event.target.value)" id="endDate" matInput [min]="minDate" [max]="maxDate" [matDatepicker]="endDatePicker" [(ngModel)]="searchCriteria.endDate" name="endDate" placeholder="End Date">
  <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
  <mat-datepicker #endDatePicker (selectedChanged)="onEndDateSelected($event)"></mat-datepicker>
  <mat-hint>mm/dd/yyyy</mat-hint>
</mat-form-field>

<mat-form-field id="endTimeFormField" class="third-width time-picker">
    <input matInput id="endTime" type="time" placeholder="End time">
  </mat-form-field>

<br/><br/><br/><br/>

<!-- REPORTING CENTER DROPDOWN   -->

  <ng-select [items]="userSearchInfo.reportingCenter"
              bindLabel="name"
              bindValue="name"
              dropdownPosition="bottom"
             [multiple]="true"
             [closeOnSelect]="false"
              placeholder="Reporting Center"
             [(ngModel)]="searchCriteria.reportingCenter"
              name="reportingCenter">
  </ng-select>

<!-- PROJECT NAMES DROPDOWN   -->

  <ng-select [items]="userSearchInfo.projectName"
              bindLabel="name"
              bindValue="name"
              dropdownPosition="bottom"
              [addTag]="true"
             [multiple]="true"
             [closeOnSelect]="false"
              placeholder="Project Name"
             [(ngModel)]="searchCriteria.projectName"
              name="projectName">
  </ng-select>

<!-- TEST TYPE DROPDOWN   -->

<ng-select [items]="userSearchInfo.testType"
            bindLabel="name"
            bindValue="name"
            dropdownPosition="bottom"
           [multiple]="true"
           [closeOnSelect]="false"
            placeholder="Test Type"
           [(ngModel)]="searchCriteria.testType"
            name="testType">
    <ng-label-tmp>
        <ng-template ng-label-tmp let-item="item">
            {{ item.name === 'BGA' ? 'BGA' : getTestTypeDisplayName(item) }}
        </ng-template>
    </ng-label-tmp>
    <ng-template ng-option-tmp let-item="item">
        {{ getTestTypeDisplayName(item) }}
    </ng-template>
</ng-select>

<mat-checkbox class="full-width mat-checkbox" type="checkbox" [(ngModel)]="searchCriteria.hasNote" name="hasNote">Show submissions with notes</mat-checkbox>


<div class="button-row">
    <button mat-raised-button type="submit">Apply</button>
    <button mat-button (click)="clear()">Clear</button>
</div>
</form>
</div>
